import React from "react";
import EditPostForm from "../Components/Forms/EditPostForm";
import EditCommentForm from "../Components/Forms/EditCommentForm";
import EditProfileForm from "../Components/Forms/EditProfileForm";
import VerifyDoctorForm from "../Components/Forms/VerifyDoctorForm";
import DeleteForm from "../Components/Forms/DeleteForm";

import MuiDialog from "@material-ui/core/Dialog";

export const Dialog = React.createContext();

export const DialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = React.useState({
    open: false,
    dialogType: "",
    dialogSize: "sm",
  });
  const [postState, setPostState] = React.useState({
    id: "",
    fromPost: "",
    message: "",
    postsTimestamp: "",
    postsName: "",
    postsTitle: "",
    postsUserID: "",
    voters: "",
    votes: 0,
  });
  const [commentState, setCommentState] = React.useState({
    id: "",
    fromPost: "",
    commentTimestamp: "",
    commentName: "",
    commentUserID: "",
    voters: "",
    votes: 0,
    comment: "",
    replyTo: "",
  });
  const [profileState, setProfileState] = React.useState({
    id: "",
    firstName: "",
    lastName: "",
    fullName: "",
    email: "",
    country: "",
    phoneNumber: 0,
    isVerified: null,
    certificateUrl: "",
  });
  const [formlessState, setFormlessState] = React.useState({
    id: "",
    fromPost: "",
  });

  const handleOpenDialog = (dialogType, dialogSize) => {
    setDialogState({
      open: true,
      dialogType: dialogType,
      dialogSize: dialogSize,
    });
  };

  const handleCloseDialog = () => {
    setDialogState({
      open: false,
      dialogType: "",
    });
  };

  let dialogContent = null;

  switch (dialogState.dialogType) {
    case "EDIT_POST":
      dialogContent = <EditPostForm {...postState} close={handleCloseDialog} />;
      break;
    case "EDIT_COMMENT":
      dialogContent = (
        <EditCommentForm {...commentState} close={handleCloseDialog} />
      );
      break;
    case "EDIT_REPLY":
      dialogContent = (
        <EditCommentForm {...commentState} close={handleCloseDialog} />
      );
      break;
    case "DELETE_POST":
      dialogContent = (
        <DeleteForm {...formlessState} close={handleCloseDialog} />
      );
      break;
    case "DELETE_COMMENT":
      dialogContent = (
        <DeleteForm {...formlessState} close={handleCloseDialog} />
      );
      break;
    case "DELETE_REPLY":
      dialogContent = (
        <DeleteForm {...formlessState} close={handleCloseDialog} />
      );
      break;
    case "EDIT_PROFILE":
      dialogContent = (
        <EditProfileForm {...profileState} close={handleCloseDialog} />
      );
      break;
    case "VERIFY_DOCTOR":
      dialogContent = (
        <VerifyDoctorForm {...formlessState} close={handleCloseDialog} />
      );
      break;
    default:
      dialogContent = null;
      break;
  }

  const state = {
    handleOpenDialog,
    setPostState,
    setCommentState,
    setProfileState,
    setFormlessState,
  };

  return (
    <Dialog.Provider value={state}>
      <MuiDialog
        open={dialogState.open}
        onClose={handleCloseDialog}
        aria-labelledby="dialog"
        maxWidth={dialogState.dialogSize}
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
      >
        {dialogContent}
      </MuiDialog>
      {children}
    </Dialog.Provider>
  );
};
